<script setup lang="ts">
import Typography from "@/components/shared/Typography.vue";

const model = defineModel<boolean>({ required: true });

const { type } = defineProps({
  type: {
    type: String,
    default: "regular",
    validator: (value: string) => {
      return ["regular", "error"].includes(value);
    },
  },
});

const emit = defineEmits(["input"]);
</script>

<template>
  <v-snackbar
    v-model="model"
    :timeout="4000"
    :class="['toast', `toast--${type}`]"
    location="left bottom"
    :min-width="0"
    @input="(val) => emit('input', val)"
  >
    <template #text>
      <Typography type="small-p" no-margin>
        <slot />
      </Typography>
    </template>
  </v-snackbar>
</template>
